import { render, staticRenderFns } from "./ControlsDialog.vue?vue&type=template&id=2a0119b5&scoped=true"
import script from "./ControlsDialog.vue?vue&type=script&lang=js"
export * from "./ControlsDialog.vue?vue&type=script&lang=js"
import style0 from "./ControlsDialog.vue?vue&type=style&index=0&id=2a0119b5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0119b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a0119b5')) {
      api.createRecord('2a0119b5', component.options)
    } else {
      api.reload('2a0119b5', component.options)
    }
    module.hot.accept("./ControlsDialog.vue?vue&type=template&id=2a0119b5&scoped=true", function () {
      api.rerender('2a0119b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/control/components/ControlsDialog.vue"
export default component.exports